import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=c2383b6e&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
import style0 from "./alert.vue?vue&type=style&index=0&id=c2383b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2383b6e",
  null
  
)

export default component.exports